import * as React from 'react';

import { Button, ButtonSize } from '@cian/button-component';

import {
  IOfferSchema,
} from '@cian/api-models/offer-card/v1/get-offer-data';
import * as styles from './index.css';
import { FOfferType, getOfferType } from '../../utils/offer_type';
import { IParent, ParentType } from '../../utils/offer_helpers';
import { getDealType, FDealType } from '../../utils/deal_type';
import { getRandomInt } from '../../utils/random';

export interface IBannerLegalSupportProps {
  offer: IOfferSchema;
  parent: IParent | undefined;
}

export interface IBannerLegalSupportState {
  banner: TBanner | null;
  images: HTMLImageElement[];
}

type TBanner = {
  text: string;
  type: string;
  landing_mark: string;
};

// Варианты баннеров для объектов аренды
const BANNERS_RENT: TBanner[] = [
  {
    landing_mark: 'arenda',
    text: 'Снимайте жильё у адекватного арендодателя',
    type: 'check-landlord',
  },
];

// Варианты баннеров для новых объектов или коттеджных поселков
const BANNERS_NEWBUILD: TBanner[] = [
  {
    landing_mark: 'zastroishik',
    text: 'Проверьте застройщика на надежность',
    type: 'check-developer',
  },
];

// Варианты баннеров для вторички
const BANNERS_VTORICHKA: TBanner[] = [
  {
    landing_mark: 'vtorichka',
    text: 'Проверьте жильё на скрытых собственников',
    type: 'check-owners',
  },
  {
    landing_mark: 'vtorichka',
    text: 'Проверьте чистоту объекта',
    type: 'check-owners',
  },
  {
    landing_mark: 'vtorichka',
    text: 'Проверьте объект и собственника',
    type: 'check-owners',
  },
];

// URL страницы лендинга для перенаправления по клику на баннер
const LENDING_URL = 'https://promo.cian.ru/legal-support/';

/* istanbul ignore next */
export class BannerLegalSupport extends React.Component <IBannerLegalSupportProps, IBannerLegalSupportState> {
  public state = {
    banner: null,
    images: [],
  };

  public componentDidMount() {
    const { offer, parent } = this.props;
    const banner = getBanner(offer, parent);

    if (banner) {
      // Это нужно для предварительной загрузки изображений
      const images = [
        require(`./img/${banner.type}.png`),
        require(`./img/${banner.type}@2x.png`),
        require(`./img/${banner.type}@3x.png`),
      ];

      (new Image()).src = images[0];
      (new Image()).src = images[1];
      (new Image()).src = images[2];
      // --

      this.setState({
        banner,
        images,
      });
    }
  }

  private handleButtonClick = () => {
    const { banner } = this.state;
    if (banner && 'landing_mark' in ((banner as unknown) as TBanner)) {
      window.open(`${LENDING_URL}#${((banner as unknown) as TBanner).landing_mark}`, '_blank');
    }
  }

  public render() {
    const { banner, images } = this.state;

    if (!banner) {
      return null;
    }

    return <div className={styles['container']}>
      <div className={styles['body']}>
        <div className={styles['title']}>{((banner as unknown) as TBanner).text}</div>
        <Button
          onClick={this.handleButtonClick}
          size={ButtonSize.S}
          className={styles['button']}
        >
          Заказать проверку
        </Button>
      </div>
      <div className={styles['container-img']}>
        <img src={images[0]} srcSet={`${images[1]} 2x, ${images[2]}`} className={styles['img']}/>
      </div>
    </div>;
  }
}

/**
 * В зависимости от типа недвижимости найдем баннер, нужный пользователю
 * @param offer
 * @param parent
 */
function getBanner(offer: IOfferSchema, parent: IParent | undefined): TBanner | null {
  let banners: TBanner[] = [];

  const offerType = getOfferType(offer);
  const dealType = getDealType(offer);

  // Новое или коттеджный поселок
  if (offerType === FOfferType.FlatNew || parent && parent.type === ParentType.KP) {
    banners = BANNERS_NEWBUILD;
  }

  // Аренда
  if (!banners.length && (dealType === FDealType.RentLongterm || dealType === FDealType.RentDaily)) {
    banners = BANNERS_RENT;
  }

  // Вторичка
  if (!banners.length && dealType === FDealType.Sale) {
    banners = BANNERS_VTORICHKA;
  }

  const index: number = getRandomInt(0, banners.length) || 0;

  return banners.length > 0
    ? banners[index]
    : null;
}
